export type DockAnchor={edge:'top'|'right';ratio:number};
export type DockBounds={width:number;height:number;viewportWidth:number;viewportHeight:number};
export type DockPoint={x:number;y:number};
const clamp=(v:number,min:number,max:number)=>Math.max(min,Math.min(v,Math.max(min,max)));
export function restoreDock(value:unknown):DockAnchor{
 const v=value as DockAnchor;
 return v&&(v.edge==='top'||v.edge==='right')&&Number.isFinite(v.ratio)?{edge:v.edge,ratio:clamp(v.ratio,0,1)}:{edge:'top',ratio:.7};
}
export function clampDock(p:DockPoint,b:DockBounds):DockPoint{return {x:clamp(p.x,8,b.viewportWidth-b.width-8),y:clamp(p.y,8,b.viewportHeight-b.height-8)};}
export function dockPoint(a:DockAnchor,b:DockBounds):DockPoint{
 const point=clampDock(a.edge==='top'?{x:8+a.ratio*Math.max(0,b.viewportWidth-b.width-16),y:8}:{x:b.viewportWidth-b.width-8,y:8+a.ratio*Math.max(0,b.viewportHeight-b.height-16)},b);
 return a.edge==='top'?{...point,y:0}:point;
}
export function snapDock(p:DockPoint,b:DockBounds):DockAnchor{
 const safe=clampDock(p,b),right=Math.max(8,b.viewportWidth-b.width-8);
 return safe.y-8<=right-safe.x?{edge:'top',ratio:(safe.x-8)/Math.max(1,b.viewportWidth-b.width-16)}:{edge:'right',ratio:(safe.y-8)/Math.max(1,b.viewportHeight-b.height-16)};
}
